import { render, staticRenderFns } from "./StartVetting.vue?vue&type=template&id=1162453e"
import script from "./StartVetting.vue?vue&type=script&lang=js"
export * from "./StartVetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports